module.exports = __webpack_public_path__ + "img/thumb_Atelier_7.0bf8c617.jpg";